module.exports = __webpack_public_path__ + "img/edit_account_2.9eef1ab7.png";